import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { LuArrowLeft } from 'react-icons/lu';

export interface ReturnButtonProps {
  path?: string;
}

const stylesheet = {
  button:
    'inline-flex items-center justify-center gap-2 w-fit z-1500 rounded-full bg-transparent border-none shadow-none outline-none cursor-pointer text-semantic-text-secondary hover:text-semantic-text-primary transition-colors',
};

export function ReturnButton({ path }: Readonly<ReturnButtonProps>) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = path ? () => navigate(path) : () => navigate(-1);

  return (
    <button type="button" className={stylesheet.button} onClick={handleClick}>
      <LuArrowLeft />
      {t('common.return')}
    </button>
  );
}
